<template>
  <n-modal
    v-model:show="modalVisible"
    preset="dialog"
    :mask-closable="false"
    :close-on-esc="false"
    :closable="false"
    :showIcon="false"
    class="real-name-reminder"
    content-class="real-name-reminder__content"
  >
    <div class="real-name-reminder__header">
      <h3 class="real-name-reminder__title">实名认证提醒</h3>
    </div>
    <p class="real-name-reminder__desc">
      您当前尚未完成实名认证。完成后可提升账号安全性，并解锁需要实名的学习与考试能力。
    </p>
    <div class="real-name-reminder__actions">
      <CustomButton width="100px" round ghost @click="handleLater"
        >稍后再说</CustomButton
      >
      <CustomButton width="100px" round type="primary" @click="handleVerify"
        >去实名认证</CustomButton
      >
    </div>
  </n-modal>
</template>

<script setup lang="ts">
import useLoginStore from '@/store/login/login'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const loginStore = useLoginStore()
const router = useRouter()

const modalVisible = computed({
  get: () => loginStore.realNameReminderVisible,
  set: (value) => {
    loginStore.realNameReminderVisible = value
  }
})

const handleLater = () => {
  loginStore.skipCurrentPostLoginReminder()
}

const handleVerify = async () => {
  loginStore.completeCurrentPostLoginReminder()
  await router.push('/personal/material/profile/verification')
}
</script>

<style lang="scss">
.real-name-reminder {
  width: 460px !important;
  padding: 0 28px 24px !important;

  &__header {
    margin: 20px 0 12px;
  }

  &__title {
    margin: 0;
    text-align: center;
    font-size: 20px;
    color: #1e1e1e;
  }

  &__desc {
    margin: 0;
    color: #606266;
    line-height: 1.8;
    font-size: 14px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
}
</style>
